<template>
	<v-form ref="formFamiliar" @submit.prevent="saveFamiliar">
		<v-card>
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Familiar</v-toolbar-title>
				<v-spacer />
				<v-icon @click.prevent="close">close</v-icon>
			</v-toolbar>
			<v-card-text>
				<v-form-creator :schema="schema" :root="form" />
			</v-card-text>
			<v-card-actions class="px-3 pb-3">
				<v-layout row :justify-center="!form.id">
					<v-btn
						v-if="checkEditar() && form.id"
						:disabled="data && data.verificada && !checkCriticas()"
						large
						dark
						color="danger"
						:block="$vuetify.breakpoint.smAndDown"
						@click.prevent="deleteFamiliar"
					>
						<v-icon class="mr-2">delete</v-icon>Remover
					</v-btn>
					<v-spacer v-if="$vuetify.breakpoint.smAndUp && form.id" />
					<v-btn
						:disabled="data && data.verificada && !checkCriticas() || !editar"
						type="submit"
						large
						dark
						color="success"
						:block="$vuetify.breakpoint.smAndDown"
					>
						<v-icon class="mr-2">save</v-icon>Salvar
					</v-btn>
				</v-layout>
			</v-card-actions>
		</v-card>

		<v-loading :show="loading" message="Processando requisição" />

		<v-confirm-dialog ref="confirmDialog" />
	</v-form>
</template>

<style>
	.v-messages__wrapper {
		color: #fd2727;
	}
</style>

<script>
	/* eslint-disable vue/no-side-effects-in-computed-properties */
	import api from '@/services/api';
	import FormModel from '@/models/form';
	import VConfirmDialog from '@/components/confirmDialog';
	import VFormCreator from '@/components/formCreator';
	import VLoading from '@/components/loading';
	import moedaFilter from '@/filters/moeda';

	export default {
		components: { VFormCreator, VLoading, VConfirmDialog },

		props: ['familiar', 'cpfs'],

		data() {
			return {
				form: new FormModel({
					id: null,
					nome: null,
					nomeSocial: null,
					cpf: null,
					dataNascimento: null,
					sexo: null,
					estadoCivil: null,
					escolaridade: null,
					deficiencia: [],
					rendaBruta: null,
					__rendaBruta: null,
					tipoRenda: null,
					parentesco: null
				}),
				loading: false,
				editar: null,
				cpfMask: '###.###.###-##',
				data: {},
				reprovado: false
			};
		},

		computed: {
			schema() {
				let { required, minlength, cpf, moeda, dataNascimento, checkRequired } = this.$rules;

				return [
					{
						label: 'Data de nascimento',
						model: 'dataNascimento',
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.data.criticaDataNascimento && this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaDataNascimento : ' ',
						persistentHint: true,
						type: 'tel',
						mask: '##/##/####',
						returnMaskedValue: true,
						rules: [required, dataNascimento(false)],
						class: { 'mr-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Nome completo',
						model: 'nome',
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.data.criticaNome && this.data.verificada,
						hint: this.data && this.editar && this.data.criticaNome ? this.data.criticaNome : ' ',
						persistentHint: true,
						rules: [required, minlength(3)],
						class: { 'ml-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Nome social (Como gostaria de ser chamado)',
						model: 'nomeSocial',
						icon: 'error',
						cols: { sm6: true },
						hint: this.familiar && this.editar ? this.data.criticaNomeSocial : ' ',
						persistentHint: true,
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.data.criticaNomeSocial && this.data.verificada,
						class: { 'mr-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'CPF',
						model: 'cpf',
						mask: '###.###.###-##',
						returnMaskedValue: false,
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.data.criticaCpf  && this.data.verificada,
						hint: this.familiar && this.editar ? this.data.criticaCpf : ' ',
						persistentHint: true,
						rules: [checkRequired(this.form.dataNascimento), this.cpfAlreadyExists, this.form.cpf ? cpf : true],
						class: { 'ml-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Parentesco',
						model: 'parentesco',
						cols: { sm3: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.familiar.criticaIdParentesco && this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaIdParentesco : ' ',
						persistentHint: true,
						items: this.$store.params.parentesco,
						rules: [required],
						class: { 'mr-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Sexo',
						model: 'sexo',
						cols: { sm3: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.familiar.criticaIdSexo && this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaIdSexo : ' ',
						persistentHint: true,
						items: this.$store.params.sexo,
						rules: [required],
						class: { 'mx-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Estado civil',
						model: 'estadoCivil',
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.familiar.criticaIdEstadoCivil && this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaIdEstadoCivil : ' ',
						persistentHint: true,
						items: this.$store.params.estadoCivil,
						rules: [required],
						class: { 'ml-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Escolaridade',
						model: 'escolaridade',
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.familiar.criticaIdEscolaridade &&  this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaIdEscolaridade : ' ',
						persistentHint: true,
						items: this.$store.params.escolaridade,
						rules: [required],
						class: { 'mr-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Deficiência(s)',
						model: 'deficiencia',
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.familiar.criticaPessoaDeficiencia && this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaPessoaDeficiencia : ' ',
						persistentHint: true,
						items: this.$store.params.deficiencia,
						multiple: true,
						listeners: {
							change: values => {
								let last = values[values.length - 1];
								let lastIsDeficiente = last && last.id === window.Config.ID_SEM_DEFICIENCIA;

								if (lastIsDeficiente) {
									this.form.deficiencia = values.filter(d => d.id === window.Config.ID_SEM_DEFICIENCIA);
								} else {
									this.form.deficiencia = values.filter(d => d.id !== window.Config.ID_SEM_DEFICIENCIA);
								}
							}
						},
						rules: [required],
						class: { 'ml-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Tipo de renda',
						model: 'tipoRenda',
						cols: { sm6: true },
						disabled: !this.editar || this.form.id && this.reprovado && this.data && !this.familiar.criticaPessoaTipoRenda && !this.familiar.criticaRendaBruta && this.data.verificada,
						hint: this.familiar && this.editar ? this.familiar.criticaPessoaTipoRenda : ' ',
						persistentHint: true,
						items: this.$store.params.tipoRenda,
						multiple: true,
						listeners: {
							change: values => {
								let last = values[values.length - 1];
								let lastIsSemRenda = last.id === window.Config.ID_TIPO_RENDA_SEM_RENDA;

								if (lastIsSemRenda) {
									this.form.tipoRenda = values.filter(tr => tr.id === window.Config.ID_TIPO_RENDA_SEM_RENDA);
								} else {
									this.form.tipoRenda = values.filter(tr => tr.id !== window.Config.ID_TIPO_RENDA_SEM_RENDA);
								}
							}
						},
						rules: [required],
						class: { 'mr-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Renda bruta mensal',
						cols: { sm6: true },
						prefix: 'R$',
						listeners: {
							change: v => {
								this.form.__rendaBruta = v;
								this.form.rendaBruta = v.replace('.', '').replace(',', '.');
							}
						},
						hint: this.familiar && this.editar ? this.familiar.criticaRendaBruta : ' ',
						persistentHint: true,
						value: moedaFilter(this.form.__rendaBruta),
						disabled: (() => {
							if (!this.editar || (this.data && this.data.verificada && this.reprovado && (this.familiar && !this.familiar.criticaRendaBruta && !this.familiar.criticaPessoaTipoRenda ))) {
								return true;
							}

							let arr = this.form.tipoRenda || [];

							if (arr.length === 0 || arr.find(tr => tr.id === window.Config.ID_TIPO_RENDA_SEM_RENDA)) {
								return true;
							}
							return false;
						})(),
						rules: (() => {
							let arr = this.form.tipoRenda || [];

							if (arr.length === 0 || arr.find(tr => tr.id !== window.Config.ID_TIPO_RENDA_SEM_RENDA)) {
								return [required, moeda];
							}

							return [];
						})(),
						class: { 'ml-2 mt-2': this.$vuetify.breakpoint.smAndUp }
					}
				];
			}
		},

		watch: {
			familiar: {
				handler() {
					if (this.familiar) {
						this.form.populate(this.familiar);

						// if (this.form.cpf) {
						// 	this.form.cpf = this.form.cpf.toString().padStart(11, 0);
						// }

						if (this.form.rendaBruta) {
							this.form.__rendaBruta = this.form.rendaBruta.toString().replace('.', ',');
						}
					}
				},

				immediate: true
			},

			'form.tipoRenda'() {
				let arr = this.form.tipoRenda || [];

				if (arr.length === 0 || arr.find(tr => tr.id === window.Config.ID_TIPO_RENDA_SEM_RENDA)) {
					this.form.__rendaBruta = null;
					this.form.rendaBruta = null;
				}
			},

			'form.deficiente'(val) {
				if (val === false) {
					this.form.deficiencia = [];
				}
			}
		},

		async created() {
			this.data = this.familiar;

			let editar = await api.fetchStatus();

			this.editar = editar.data.operacoes.editar;

			this.reprovado = editar.data.situacaoInscricao.descricao == 'Reprovada';

			if (!this.editar) {
				document.getElementsByClassName('v-text-field__prefix')[0].style.color = '#ddd';
			}
		},

		methods: {
			checkRequired() {
				return 'required';
			},

			async saveFamiliar() {
				if(this.form.rendaBruta > window.Config.RENDA_MAXIMA) {
					this.$refs.confirmDialog
						.open('Renda bruta mensal declarada (R$ ' + this.form.rendaBruta + ') é superior a 7 salários mínimos, o que faz com que a inscrição não participe do programa habitacional.<br><br> Informação declarada está correta?')
						.then(async response => {
							if(response) {
								this.saveAndMessage();
							}
						});
				} else {
					this.saveAndMessage();
				}
			},

			async saveAndMessage() {
				let url = '/inscricao/membroFamilia';

				if (this.form.id) {
					url += `/${this.form.id}`;
				}

				if (this.$refs.formFamiliar.validate()) {
					try {
						this.loading = true;

						await this.form.save(url);

						this.$store.$emit('show-message', {
							message: `Familiar ${this.form.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
							color: 'success'
						});

						this.close(false);
					} catch ({ data: { message } }) {
						if (message) {
							this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
						}
					} finally {
						this.loading = false;
					}
				}
			},

			async deleteFamiliar() {
				this.$refs.confirmDialog
					.open(`Confirma a remoção de <strong class="primary--text">${this.form.nome}</strong> da família?`)
					.then(async response => {
						if (response) {
							try {
								this.loading = true;

								await this.form.remove(`/inscricao/membroFamilia/${this.form.id}`);

								this.$store.$emit('show-message', { message: 'Familiar removido com sucesso!', color: 'success' });

								this.close();
							} catch ({ data: { message } }) {
								if (message) {
									this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
								}
							} finally {
								this.loading = false;
							}
						}
					});
			},

			checkCriticas() {
				let keys = Object.keys(this.data);
				for (let i = 0; i < keys.length; i++) {
					if (keys[i].includes('critica')) {
						return true;
					}
				}
				return false;
			},

			checkEditar() {
				return this.editar;
			},

			cpfAlreadyExists(v) {
				if (this.cpfs && this.familiar && v !== this.familiar.cpf) {
					return this.cpfs.includes(v) ? 'CPF já cadastrado' : true;
				}

				return true;
			},

			close(reset = true) {
				this.$emit('close');

				if (reset) {
					this.$refs.formFamiliar.reset();
				}
			}
		}
	};
</script>